export default { props: [ 'minDate', 'maxDate' ] };